module.exports = __webpack_public_path__ + "img/groups.ac116958.png";